import m from "../../../../geodata/es2015/region/usa/ctHigh";
window.am4geodata_region_usa_ctHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/ctHigh.js
// module id = null
// module chunks = 